export class FormRequestHealthSystem {
  name: string
  email: string
  website: string
  street_address: string
}
